/**
 * チャートの期間内にタスクが入っているかどうか判定するポリシー
 */
export default class ChartTaskPolicy {
  public constructor(private chart: Interval) {}

  public isSatisfied(task: Interval): boolean {
    if (task.end < this.chart.start) return false;
    if (this.chart.end < task.start) return false;
    return true;
  }
}
